
// Erklärung access token etc https://developer.spotify.com/documentation/general/guides/authorization-guide/#implicit-grant-flow

// import { useStateValue } from "./StateProvider";

// const { default: SearchFormNew } = require("./jammming-src/Components/SearchBar/SearchFormNew");



//app jammming (in https://developer.spotify.com/dashboard/applications/8c274981e5dd4359abe364d978cfc178)  aber clientId nicht rausgeben

/*
const clientId = "eaa9a87d8dda4acfa0530445e368012a";

const redirectUri = 'http://localhost:3000/';


//leere Variabel, die Users Access Token halten wird 
let accessToken;


const SpotifyJam = {
    getAccessToken()  {


        //wenn es schon einen gibt
        if(accessToken)  {

            return accessToken;

        }
            // check for access token match 
            
                                                            //REGEX um nur access_token zu holen
            const accessTokenMatch = window.location.href.match(/access_token=([^&]*)/); 
            //window.location.href kann einfach zu unterst in Console der Browser Tools eingetippt werden um zu sehen wo wir sind (bei jeder Website)

                                                                //REGEX um nur expires in zu holen
            const expiresInMatch = window.location.href.match(/expires_in=([^&]*)/);

            //Wenn diese beiden in URL exisitieren 
            if (accessTokenMatch && expiresInMatch) {

                accessToken = accessTokenMatch[1];
                const expiresIn = Number(expiresInMatch[1]);

                //Parameter aus URL entfernen damit wird ermöglicht neuen accessToken zu holen wenn bestehender expired 
                    //wenn alles auf einer Linie keine curly braces {} nötig
                    window.setTimeout( () => accessToken ='', expiresIn * 1000);
                    window.history.pushState('Access Token', null, '/');
                    return accessToken;


            } else //hier wird zu login fenster geleteitet (wenn accessToken nicht vorhanden)


            {
                    //URL backticks `` URL Dollar-Sign für Variabeln
                const accessUrl = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=token&scope=playlist-modify-public&redirect_uri=${redirectUri}`;

                //was in der Browser Bar eingegeben wird
                window.location = accessUrl;
 
               }
  
    },

    */


   const SpotifyJam = {

  
    //method für search songs
    search(suchbegriff, token) {
      
      
        

        const accessToken = token; 

        //hier ist endpoint : Argument 1 ist suchbegriff zu endpoint
        return fetch(`https://api.spotify.com/v1/search?type=track&q=${suchbegriff}`, { 
            headers: {

            Authorization: `Bearer ${accessToken}`
        }
            
            //convert result to JSON
         }).then(response => {

            return response.json();


        }).then(jsonResponse => {
            //wenn keine resultate, empty array zurückgeben
            if (!jsonResponse.tracks) {
                return [];
                
            }

            //wenn resultate durchgehen und mappen
           
            return jsonResponse.tracks.items.map(track => ({
            id: track.id,
            name: track.name,
            artist: track.artists[0].name,
            artistid: track.artists[0].id,
            album: track.album.name,
            albumid: track.album.id,
            uri: track.uri,


      
            tracknumber: track.track_number,
            popularity: track.popularity,













        }));
        });
    },


    //method für album search spezfisch nach id
    searchAlbum(suchbegriff, suchbegriffkuenstler, token) {
      
      
        

        const accessToken = token; 

        //hier ist endpoint : Argument 1 ist suchbegriff zu endpoint
        return fetch(`https://api.spotify.com/v1/search?type=track&q=album:${suchbegriff}%20artist:${suchbegriffkuenstler}`, { 
            headers: {

            Authorization: `Bearer ${accessToken}`
        }
            
            //convert result to JSON
         }).then(response => {

            return response.json();


        }).then(jsonResponse => {
            //wenn keine resultate, empty array zurückgeben
            if (!jsonResponse.tracks) {
                return [];
                
            }

            //wenn resultate durchgehen und mappen
           
            return jsonResponse.tracks.items.map(track => ({
            id: track.id,
            name: track.name,
            artist: track.artists[0].name,
            artistid: track.artists[0].id,
            album: track.album.name,
            albumid: track.album.id,
            uri: track.uri,
            tracknumber: track.track_number,
            popularity: track.popularity,
        }));
        });
    },


   //method für search playlist
   playlistsearch(suchbegriff, token) {
      
      
        

    const accessToken = token; 

    //hier ist endpoint : Argument 1 ist suchbegriff zu endpoint
    return fetch(`https://api.spotify.com/v1/search?type=playlist&q=${suchbegriff}`, { 
        headers: {

        Authorization: `Bearer ${accessToken}`
    }
        
        //convert result to JSON
     }).then(response => {

        return response.json();


    }).then(jsonResponse => {
        //wenn keine resultate, empty array zurückgeben
        if (!jsonResponse.playlists) {
            return [];
            
        }

        //wenn resultate durchgehen und mappen
       
        return jsonResponse.playlists.items.map(playlist => ({
        // id: playlist.id,
        name: playlist.name,
        description: playlist.description,
        uri: playlist.uri,
        owner: playlist.owner.display_name
       // followers: playlist.followers.total
    }));
    });
},



   //method für list user playlists
   listuserplaylists(token) {
      
      
        

    const accessToken = token; 


    //Variabel headers als OBJEKT gesetzt
    const headers = { Authorization: `Bearer ${accessToken}` };
    let userId;


    return fetch('https://api.spotify.com/v1/me', { headers: headers }
    ).then(response => response.json()
    ).then(jsonResponse => {

        userId = jsonResponse.id;

       // alert (userId);
    
    //hier ist endpoint
    return fetch(`https://api.spotify.com/v1/users/${userId}/playlists`, { 
     
          headers: headers,
        method: 'GET',
    

        Authorization: `Bearer ${accessToken}`
     //   body: JSON.stringify( {} )
        
        //convert result to JSON
     }).then(response => {

        return response.json();


    }).then(jsonResponse => {
        //wenn keine resultate, empty array zurückgeben
        if (!jsonResponse) {
           
            alert (userId);
            return [];
            
        }

        //wenn resultate durchgehen und mappen
       
        return jsonResponse.items.map(playlist => ({
        // id: playlist.id,
        name: playlist.name,
        description: playlist.description,
        uri: playlist.uri,
        id: playlist.id
       //  followers: playlist.followers (geht nicht)
    }));
    });

});
},

//method für list user playlists
listplaylistsongs(token, playlistId) {
      
      
        

    const accessToken = token; 


    //Variabel headers als OBJEKT gesetzt
    const headers = { Authorization: `Bearer ${accessToken}` };
    let userId;


    return fetch('https://api.spotify.com/v1/me', { headers: headers }
    ).then(response => response.json()
    ).then(jsonResponse => {

        userId = jsonResponse.id;

       // alert (userId);
    
    //hier ist endpoint
    return fetch(`https://api.spotify.com/v1/playlists/${playlistId}/tracks`, { 
     
          headers: headers,
        method: 'GET',
    

        Authorization: `Bearer ${accessToken}`
     //   body: JSON.stringify( {} )
        
        //convert result to JSON
     }).then(response => {

        return response.json();


    }).then(jsonResponse => {
        //wenn keine resultate, empty array zurückgeben
        if (!jsonResponse) {
           
            alert (userId);
            return [];
            
        }

        //wenn resultate durchgehen und mappen
       
        return jsonResponse.items.map(playlisttrack => ({
        // id: playlist.id,
       // track: playlisttrack.track


        id: playlisttrack.track.id,
        name: playlisttrack.track.name,
        artist: playlisttrack.track.artists[0].name,
        artistid: playlisttrack.track.artists[0].id,
        album: playlisttrack.track.album.name,
        albumid: playlisttrack.track.album.id,
        uri: playlisttrack.track.uri,


  
        tracknumber: jsonResponse.items.indexOf(playlisttrack)+1,
        popularity: playlisttrack.track.popularity,
        // length: jsonResponse.items.length,
       
       positionInPlaylist: jsonResponse.items.indexOf(playlisttrack)+1,
      
     //   songindex: playlisttrack.track.index,







       //  followers: playlist.followers (geht nicht)
    }));
    });

});
},



//method für list album songs
listalbumidsongs(token, albumId) {
      
      
        

    const accessToken = token; 


    //Variabel headers als OBJEKT gesetzt
    const headers = { Authorization: `Bearer ${accessToken}` };
    let userId;


    return fetch('https://api.spotify.com/v1/me', { headers: headers }
    ).then(response => response.json()
    ).then(jsonResponse => {

        userId = jsonResponse.id;

       // alert (userId);
   
    //hier ist endpoint
    return fetch(`https://api.spotify.com/v1/albums/${albumId}/tracks`, { 
     
          headers: headers,
        method: 'GET',
    

        Authorization: `Bearer ${accessToken}`
     //   body: JSON.stringify( {} )
        
        //convert result to JSON
     }).then(response => {

        return response.json();


    }).then(jsonResponse => {
        //wenn keine resultate, empty array zurückgeben
        if (!jsonResponse) {
           
            alert (userId);
            return [];
            
        }

        //wenn resultate durchgehen und mappen
       
        return jsonResponse.items.map(track => ({
        // id: playlist.id,
       // track: playlisttrack.track


        id: track.id,
        name: track.name,
        artist: track.artists[0].name,
        artistid: track.artists[0].id,
     //   album: track.album.name,
       albumid: albumId,
        uri: track.uri,


  
        tracknumber: track.track_number,
        popularity: track.popularity,
        // length: jsonResponse.items.length,
       
    
      
     //   songindex: playlisttrack.track.index,







       //  followers: playlist.followers (geht nicht)
    }));
    });

});
},

//method für getArtistImages
getArtistImages(artistIdForImage, token) {
      
      
        

    const accessToken = token; 


    //Variabel headers als OBJEKT gesetzt
    const headers = { Authorization: `Bearer ${accessToken}` };
    let userId;


    return fetch('https://api.spotify.com/v1/me', { headers: headers }
    ).then(response => response.json()
    ).then(jsonResponse => {

        userId = jsonResponse.id;

       // alert (userId);
    
    //hier ist endpoint
    return fetch(`https://api.spotify.com/v1/artists/${artistIdForImage}`, { 
     
   

          headers: headers,
        method: 'GET',
    

        Authorization: `Bearer ${accessToken}`
     //   body: JSON.stringify( {} )
        
        //convert result to JSON
     }).then(response => {

        return response.json();


    }).then(jsonResponse => {
        //wenn keine resultate, empty array zurückgeben
        if (!jsonResponse) {
           
         //   alert (userId);
            return [];
            
        }

        //wenn resultate durchgehen und mappen
       
        return jsonResponse;
        

  });

});
},





////PLAYER INFO START
getPlayerInfo(token) {
      
      

    const accessToken = token; 


    //Variabel headers als OBJEKT gesetzt
    const headers = { Authorization: `Bearer ${accessToken}` };




       // alert (userId);
    
    //hier ist endpoint
    return fetch(`https://api.spotify.com/v1/me/player/currently-playing`, { 
     
   

          headers: headers,
        method: 'GET',
    

        Authorization: `Bearer ${accessToken}`
     //   body: JSON.stringify( {} )
        
        //convert result to JSON
     }).then(response => {

        return response.json();


    }).then(jsonResponse => {
        //wenn keine resultate, empty array zurückgeben
        if (!jsonResponse) {
           
   
            return [];
            
        }

   
        //wenn resultate durchgehen und mappen
        


        return jsonResponse;
           
   
 
  });


}, //PLAYERINFO END


////userid start
getUserInfo(token) {
      
      
        

    const accessToken = token; 


    //Variabel headers als OBJEKT gesetzt
    const headers = { Authorization: `Bearer ${accessToken}` };




   

       // alert (userId);
    
    //hier ist endpoint
    return fetch(`https://api.spotify.com/v1/me`, { 
     
   

          headers: headers,
        method: 'GET',
    

        Authorization: `Bearer ${accessToken}`
     //   body: JSON.stringify( {} )
        
        //convert result to JSON
     }).then(response => {

        return response.json();


    }).then(jsonResponse => {
        //wenn keine resultate, empty array zurückgeben
        if (!jsonResponse) {
           
         //   alert (userId);
            return [];
            
        }

        //wenn resultate durchgehen und mappen
       
        return jsonResponse;
        
        //.item.map(playlisttrack => ({
          
        // id: playlist.id,
       
       
   //  url: playlisttrack.artist.images.url,
        
        //.items.map(artist => ({

 
 // artistImages: artist.images;

       //  followers: playlist.followers (geht nicht)
//}));
  });


}, //userid end


//method für getAlbumImage
getAlbumImage(albumIdForImage, token) {
      
      
        

    const accessToken = token; 


    //Variabel headers als OBJEKT gesetzt
    const headers = { Authorization: `Bearer ${accessToken}` };
    let userId;


    return fetch('https://api.spotify.com/v1/me', { headers: headers }
    ).then(response => response.json()
    ).then(jsonResponse => {

        userId = jsonResponse.id;

       // alert (userId);
    
    //hier ist endpoint
    return fetch(`https://api.spotify.com/v1/albums/${albumIdForImage}`, { 
     
   

          headers: headers,
        method: 'GET',
    

        Authorization: `Bearer ${accessToken}`
     //   body: JSON.stringify( {} )
        
        //convert result to JSON
     }).then(response => {

        return response.json();


    }).then(jsonResponse => {
        //wenn keine resultate, empty array zurückgeben
        if (!jsonResponse) {
           
         //   alert (userId);
            return [];
            
        }

        //wenn resultate durchgehen und mappen
       
        return jsonResponse;
        
        //.item.map(playlisttrack => ({
          
        // id: playlist.id,
       
       
   //  url: playlisttrack.artist.images.url,
        
        //.items.map(artist => ({

 
 // artistImages: artist.images;

       //  followers: playlist.followers (geht nicht)
//}));
  });

});
},



//method für track info
getTrackInfo(trackIdForInfo, token) {
      
      
        

    const accessToken = token; 


    //Variabel headers als OBJEKT gesetzt
    const headers = { Authorization: `Bearer ${accessToken}` };
    let userId;


    return fetch('https://api.spotify.com/v1/me', { headers: headers }
    ).then(response => response.json()
    ).then(jsonResponse => {

        userId = jsonResponse.id;

       // alert (userId);
    
    //hier ist endpoint 	
    return fetch(`https://api.spotify.com/v1/tracks/${trackIdForInfo}`, { 
     
   

          headers: headers,
        method: 'GET',
    

        Authorization: `Bearer ${accessToken}`
     //   body: JSON.stringify( {} )
        
        //convert result to JSON
     }).then(response => {

        return response.json();


    }).then(jsonResponse => {
        //wenn keine resultate, empty array zurückgeben
        if (!jsonResponse) {
           
         //   alert (userId);
            return [];
            
        }

        //wenn resultate durchgehen und mappen
       
        return jsonResponse;
        
        //.item.map(playlisttrack => ({
          
        // id: playlist.id,
       
       
   //  url: playlisttrack.artist.images.url,
        
        //.items.map(artist => ({

 
 // artistImages: artist.images;

       //  followers: playlist.followers (geht nicht)
//}));
  });

});
},


    //function resp. method für save playlist
    savePlaylist(name, trackUris) {
        //wenn leer direkt return
        if (!name || !trackUris.length) {

            return;
        }

        //erklärt um die 2h

        //Variabel mit accessToken des Benutzers
        const accessToken = SpotifyJam.getAccessToken();
        //Variabel headers als OBJEKT gesetzt
        const headers = { Authorization: `Bearer ${accessToken}` };
        let userId;


        return fetch('https://api.spotify.com/v1/me', { headers: headers }
        ).then(response => response.json()
        ).then(jsonResponse => {

            userId = jsonResponse.id;
            return fetch(`https://api.spotify.com/v1/users/${userId}/playlists` , 
            {
            headers: headers,
            method: 'POST',
                                //Objekt
            body: JSON.stringify( {name: name} )
            }).then(response => response.json()
            ).then(jsonResponse => {

                const playlistId = jsonResponse.id;
                return fetch(`https://api.spotify.com/v1/v1/users/${userId}/playlists/${playlistId}/tracks` ,
                {
                    headers: headers,
                    method: 'POST',
                    body: JSON.stringify( { uris: trackUris} )

                });
            });

        });
    }


}


 export default SpotifyJam;